import React, { Component } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { Error } from '../../pages/404';

export class ErrorBoundary extends Component {
  static contextType = AnalyticsContext;

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { trackEvent } = this.context;
    trackEvent('issue rendering ui', { error, errorInfo });

    console.error('There was an error trying to render', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) return <Error />;

    return this.props.children;
  }
}
